import { SeitenlokalisationDisplayNameEnum } from './seitenlokalisation-display-name.enum';
import { SeitenlokalisationOption } from './seitenlokalisation-option.interface';
import { SeitenlokalisationEnum } from './seitenlokalisation.enum';

export const SEITENLOKALISATION_OPTIONS: SeitenlokalisationOption[] = [
  {
    id: SeitenlokalisationEnum.Links,
    name: SeitenlokalisationDisplayNameEnum.Links,
  },
  {
    id: SeitenlokalisationEnum.Beidseitig,
    name: SeitenlokalisationDisplayNameEnum.Beidseitig,
  },
  {
    id: SeitenlokalisationEnum.Rechts,
    name: SeitenlokalisationDisplayNameEnum.Rechts,
  },
  {
    id: undefined,
    name: SeitenlokalisationDisplayNameEnum.KeineAuswahl,
  },
];
